<template>
  <a-drawer
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @cancel="onClose"
    @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="activityId" >
        <span slot="label" ><a-tooltip>{{ $t('活动ID') }}<template slot="title">{{ $t('活动ID') }}</template></a-tooltip> </span>
        <a-input-number v-model="form.activityId" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'活动ID'" />
      </a-form-model-item>
      <a-form-model-item prop="userId" >
        <span slot="label" ><a-tooltip>{{ $t('用户ID') }}<template slot="title">{{ $t('用户ID') }}</template></a-tooltip> </span>
        <a-input-number v-model="form.userId" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'用户ID'" />
      </a-form-model-item>
      <a-form-model-item prop="roleName" >
        <span slot="label" ><a-tooltip>{{ $t('角色名称') }}<template slot="title">{{ $t('角色名称') }}</template></a-tooltip> </span>
        <a-input v-model="form.roleName" :maxLength="128" :placeholder="$t('请输入')+'角色名称'" >
        </a-input>
      </a-form-model-item>
      <a-form-model-item prop="roleImage" >
        <span slot="label" ><a-tooltip>{{ $t('角色图片') }}<template slot="title">{{ $t('角色图片') }}</template></a-tooltip> </span>
        <oss-upload-single height="100" width="100" v-model="form.roleImage" prefix="community" type="img"/>
     </a-form-model-item>
      <a-form-model-item prop="checkinPointId" >
        <span slot="label" ><a-tooltip>{{ $t('打卡点ID') }}<template slot="title">{{ $t('打卡点ID') }}</template></a-tooltip> </span>
        <a-input-number v-model="form.checkinPointId" style="width: 100%" :max="9999999" :placeholder="$t('请输入')+'打卡点ID'" />
      </a-form-model-item>
      <a-form-model-item prop="checkinPointName" >
        <span slot="label" ><a-tooltip>{{ $t('打卡点名称') }}<template slot="title">{{ $t('打卡点名称') }}</template></a-tooltip> </span>
        <a-input v-model="form.checkinPointName" :maxLength="128" :placeholder="$t('请输入')+'打卡点名称'" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
  import { getCommunityGroupActivityCheckin, addCommunityGroupActivityCheckin, updateCommunityGroupActivityCheckin } from '@/api/community/communityGroup/communityGroupActivityCheckin'
  import { mapGetters } from 'vuex'
  import CustomDictTag from '@/components/DictCustomTag'
  import { generateFilePath, uploadObject } from '@/api/tool/oss'
  import OssUploadSingle from '@/components/OssUploadSingle/index.vue'
  import LocaleFieldButton from '@/components/locale/LocaleFieldButton.vue'
  import moment from 'moment'

  export default {
    name: 'CreateForm',
  props: {
  },
  components: {
      CustomDictTag,
      LocaleFieldButton,
      OssUploadSingle
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      loading: '',
      // 表单参数
      form: {
        activityId: null,
        userId: null,
        roleName: null,
       roleImage: null,
       checkinPointId: null,
        checkinPointName: null,
        
        
        localeFieldMap: {}
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
          userId: [{ required: true, message: this.$t('用户ID') + this.$t('不能为空'), trigger: 'blur' }],
          roleName: [{ required: true, message: this.$t('角色名称') + this.$t('不能为空'), trigger: 'blur' }],
          checkinPointName: [{ required: true, message: this.$t('打卡点名称') + this.$t('不能为空'), trigger: 'blur' }]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    moment,
    onClose () {
      this.cancel()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        activityId: null,
        userId: null,
        roleName: null,
       roleImage: null,
       checkinPointId: null,
        checkinPointName: null,
        
        
        localeFieldMap: {}
      }
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCommunityGroupActivityCheckin({ 'id': id }).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = ''
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateCommunityGroupActivityCheckin(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addCommunityGroupActivityCheckin(this.form).then(response => {
              if (response.code === '20001') {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
  }
</script>
